import { vkuiUseExternRef } from '@dui/vkuiReexports';

export function useExternRef<T>(...args: Array<React.Ref<T> | undefined | false>): React.RefObject<T | null> {
  return vkuiUseExternRef(...args);
}
